var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.$props.className,attrs:{"alt":_vm.$props.alt,"href":_vm.getHrefWithQueryParams,"rel":_vm.$props.rel,"target":_vm.$props.target,"title":_vm.$props.title}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }